import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMoveFolder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMoveFolder"><Path d="M23.4141 17L19.207 21.207L17.793 19.793L19.5859 18H14V16H19.5859L17.793 14.207L19.207 12.793L23.4141 17Z" fill="currentColor"/><Path d="M12.5352 6H22V12.7578L19.207 9.96484L15.1719 14H12V20H2V3H10.5352L12.5352 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMoveFolder;
